<template>
  <div class="home" id="home">
    <el-container>
      <el-header v-if="isShow">前台考勤开发</el-header>
      <el-container>
        <el-aside width="200px" v-if="isShow">
          <ul>
            <li
              v-for="(item, index) in menu"
              :key="index"
              @click="clickPage(index, item)"
            >
              <span :class="index == spanNum ? 'spanColor' : ''">{{
                item.name
              }}</span>
            </li>
          </ul>
        </el-aside>
        <el-container>
          <el-main :class="{ 'dev-main': isShow }">
            <keep-alive>
              <router-view
                tag="div"
                class="link"
                v-if="$route.meta.keepAlive"
              ></router-view>
            </keep-alive>
            <router-view
              tag="div"
              class="link"
              v-if="!$route.meta.keepAlive"
            ></router-view>
          </el-main>
        </el-container>
      </el-container>
    </el-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      spanNum: 0,
      menu: [
        {
          id: "AttendanceRule",
          name: "考勤规则",
          src: "AttendanceRule",
        }, 
        {
          id: "AttendanceWay",
          name: "考勤方式",
          src: "AttendanceWay",
        },       
        {
          id: "PersonMange",
          name: "人员管理",
          src: "PersonMange",
        },
        {
          id: "DepartmentMange",
          name: "部门管理",
          src: "DepartmentMange",
        },
        {
          id: "AttendanceStatement",
          name: "考勤报表",
          src: "AttendanceStatement",
        },
        {
          id: "AttendanceArrange",
          name: "班次管理",
          src: "AttendanceArrange",
        },
        {
          id: "AttendanceMange",
          name: "考勤组管理",
          src: "AttendanceMange",
        },
        {
          id: "OverTimeRuleList",
          name: "加班规则",
          src: "OverTimeRuleList",
        },
        {
          id: "Statistics",
          name: "打卡原始记录",
          src: "Statistics",
        },
        {
          id: "AttendanceClock",
          name: "考勤签到",
          src: "AttendanceClock",
        },
        {
          id: "AttendanceCollect",
          name: "考勤汇总",
          src: "AttendanceCollect",
        },
        {
          id: "VacationSet",
          name: "假期设置",
          src: "VacationSet",
        },
        // {
        //   id: "VacationBalance",
        //   name: "假期余额（旧）(隐藏)",
        //   src: "VacationBalance",
        // },
        {
          id: "LeaveRecord",
          name: "请假记录",
          src: "LeaveRecord",
        },
        {
          id: "VacationType",
          name: "假期类型",
          src: "VacationType",
        },
        {
          id: "VacationBalanceNew",
          name: "假期余额",
          src: "VacationBalanceNew",
        },
        {
          id: "Auditing",
          name: "审批管理",
          src: "Auditing",
        },
        {
          id: "AbnormalDevice",
          name: "异常设备管理",
          src: "AbnormalDevice",
        },
        {
          id: "ShiftManagementList",
          name: "排班管理",
          src: "ShiftManagementList",
        },
         {
          id: "PackageIndex",
          name: "套餐管理",
          src: "PackageIndex",
        },
         {
          id: "OrderManage",
          name: "订单管理",
          src: "OrderManage",
        },
      ],
      isShow: false,
    };
  },
  created() {
    this.isShow = process.env.NODE_ENV == "development" ? true : false;
    // this.isShow = false;
  },
  methods: {
    clickPage(num, item) {
      this.spanNum = num;
      this.$router.push(item.src);
    },
  },
};
</script>
<style scoped lang="less">
.home {
  position: fixed;
  width: 100%;
  height: 100%;
}
.el-container {
  height: 100%;
}
.el-header {
  background-color: #30323f;
  color: #fff;
  text-align: center;
  line-height: 60px;
}
.el-aside {
  background-color: #fff;
  color: #000;
  text-align: center;
  border-right: 1px solid #e2e2e2e2;
  ul {
    li {
      line-height: 40px;
      text-align: center;
    }
    .sonPage {
      // display: none;
      position: fixed;
      text-align: left;
      left: 200px;
      top: 100px;
      width: 140px;
      padding-left: 40px;
      background-color: #fff;
      // box-shadow: 0 0 20px 0 #b9dcf4;
      z-index: 10000000;
      p {
        left: 200px;
        color: #000;
        line-height: 60px;
        cursor: pointer;
        // position: relative;
      }

      p:hover {
        color: #f08200;
      }
      .firstSpan {
        content: "";
        position: absolute;
        left: 10px;
        top: 13px;
        width: 2px;
        height: 25px !important;
        background-color: #fff;
        height: 100%;
      }
      .twoSpan {
        top: 73px !important;
      }
      .thirdSpan {
        top: 133px !important;
      }
      .checkedColor {
        color: #f08200;
      }
      #checkBackgroundClor {
        background-color: #f08200;
      }
    }
    li:hover span {
      color: rgb(255, 126, 0);
    }
    li {
      span {
        cursor: pointer;
      }
    }
    .spanColor {
      color: rgb(255, 126, 0);
    }
  }
}

.el-main {
  height: 100%;
  background-color: #edf1f5;
  color: #000;
  text-align: center;
  padding: 0;
}
.dev-main {
  height: calc(100% - 60px);
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue